import { PropertyPath } from '../engine.js';

/***
 * For plain JSON objects only
 */
export class JsonPath {
  constructor(private obj: object) {
  }

  update(path: PropertyPath, setter: (oldValue: any) => any) {
    const properties = path.split('.');
    let refs = [{
      value: this.obj, setter: (a) => {
      }
    }];
    while (properties.length > 0) {
      const current = properties.shift();
      let nextRefs = [];
      while (refs.length > 0) {
        const ref = refs.pop();
        const value = ref.value;
        if (Array.isArray(value)) {
          // current - index of array
          if (Number.isFinite(+current)) {
            if (current in value) {
              nextRefs.push({
                value: value[current], setter: (v) => {
                  value[current] = v;
                }
              });
            }
          } else {
            // current - propertyname of array element
            for (let element of value) {
              if (current in element) {
                nextRefs.push({
                  value: element[current], setter: (v) => {
                    element[current] = v;
                  }
                })
              }
            }
          }
        } else {
          if (current in value) {
            nextRefs.push({ value: value[current], setter: (v) => value[current] = v });
          }
        }
      }
      refs = nextRefs;
    }

    for (const ref of refs) {
      const v = ref.value;
      if (Array.isArray(v)) {
        for (let i = 0; i < v.length; i++) {
          const value = v[i];
          v[i] = setter(value);
        }
      } else {
        const newValue = setter(ref.value);
        ref.setter(newValue);
      }
    }
  }
}
